import { SOCIAL_PLATFORMS } from '../../config/platformCapabilities';

export function apiPlatformToRouteId(apiPlatform: string): string {
  const upper = apiPlatform.toUpperCase();
  const match = SOCIAL_PLATFORMS.find((p) => p.apiPlatform === upper);
  if (match) return match.id;
  if (upper === 'TWITTER') return 'x';
  return upper.toLowerCase();
}
